import { FlowStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { useTranslation } from "@redotech/redo-i18n";
import CheckCircleIcon from "@redotech/redo-icons/check-circle_filled.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

/**
 * Compensation and Restocking steps share the Process Return node visual on
 * the canvas until they get a dedicated one, so this node accepts all three
 * step types.
 */
type ProcessReturnSharedStep = Extract<
  FlowStep,
  {
    type:
      | StepType.PROCESS_RETURN
      | StepType.COMPENSATION_STEP
      | StepType.RESTOCKING_STEP;
  }
>;

export interface ProcessReturnNodeData {
  step: PartialWithRequiredType<ProcessReturnSharedStep>;
  deleteElements: (id: string) => void;
  hovered?: boolean;
}

export const ProcessReturnNode = memo(function ProcessReturnNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: ProcessReturnNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="success"
            Icon={CheckCircleIcon}
            shape="circle"
            size="md"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title={t("Process return")}
      />
      <Handle position={Position.Bottom} type="source" />
    </>
  );
});
